import { PaletteDocument } from '@/models/PaletteDocument';
import { Pointage } from '@/models/Pointage';
import { Supplement } from '@/models/Supplement';
import { TarifActiviteDocument } from '@/models/TarifActiviteDocument';
import { TarifEventSchedulerActiviteDocument } from '@/models/TarifEventSchedulerActiviteDocument';
import { GroupeIndividu } from '@/models/GroupeIndividu';
import { VieQuotidienneDocuments } from '@/models/VieQuotidienneDocument';
import { Individu } from '@/models/Individu';

export interface PointageState {
    pointageEnCours : Array<Pointage>
    listTempsAccueil : Array<TarifEventSchedulerActiviteDocument>
    listSupplements : Array<TarifActiviteDocument>
    listTempsAccueilFiltred : Array<TarifEventSchedulerActiviteDocument>
    listSupplementsFiltred : Array<TarifActiviteDocument>
    listPointagesPrevi : Array<any>
    paletteEncours : PaletteDocument
    listSupplementsActifs: Array<Supplement>
    listSupplementsPrevi: Array<any>
    lastAction: {
        name: string,
        value: any
    }
    listPalettePresence: Array<PaletteDocument>
    listPaletteAbsence: Array<PaletteDocument>
    listGroupes: Array<GroupeIndividu>
    listRegim: Array<VieQuotidienneDocuments>
    individusPresents: Array<Individu>,
    individusFiltreesPresents: Array<Individu>,
    vieQuoRegimeAli: Array<string>
}
export enum POINTAGES_STORE {
    /* Mutations */
    SET_POINTAGE_ENCOURS = "SET_POINTAGE_ENCOURS",
    ADD_POINTAGE_ENCOURD="ADD_POINTAGE_ENCOURD",
    SET_LIST_TEMPS_ACCUEIL = "SET_LIST_TEMPS_ACCUEIL",
    SET_LIST_SUPPLEMENTS = "SET_LIST_SUPPLEMENTS",
    SET_LIST_TEMPS_ACCUEIL_FILTRED = "SET_LIST_TEMPS_ACCUEIL_FILTRED",
    SET_LIST_SUPPLEMENTS_FILTRED = "SET_LIST_SUPPLEMENTS_FILTRED",
    SET_POINTAGE_PREVI = "SET_POINTAGE_PREVI",
    SET_PALETTE_ENCOURS = "SET_PALETTE_ENCOURS",
    SET_SUPPLEMENTS_ACTIFS = "SET_SUPPLEMENTS_ACTIFS",
    SET_LAST_ACTION = "SET_LAST_ACTION",
    SET_POINTAGE_REEL = "setPointageReel",
    SET_LIST_PALETTE_PRESENCE = "setListPalettePresence",
    SET_LIST_PALETTE_ABSENCE = "setListPaletteAbsence",
    SET_LIST_GROUPES = "setListGroupes",
    SET_LIST_REGIM = "setListRegim",
    SET_SUPPLEMENTS_PREVI = "setSupplementsPrevi",
    SET_INDIVIDUS_PRESENT = "SET_INDIVIDUS_PRESENT",
    SET_INDIVIDUS_FILTREES_PRESENT = "SET_INDIVIDUS_FILTREES_PRESENT",
    SET_VIE_REGIM_ALI = "SET_VIE_REGIM_ALI"
}